<template>
  <a-row :gutter="24" type="flex" v-if="visitData.today">
    <a-col v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 12 }" style="margin-bottom: 24px">
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '20px 24px 8px 24px' }">
        <field-big
          label="今日我的收款/付款客人数量："
          :value="`${numeral(visitData.today.cz_price).format('0,0')}元/${
            visitData.today.cz_customer
          }人`"
        />
        <field
          label="昨日我的收款/付款客人数量："
          :value="`${numeral(visitData.yesterday.cz_price).format('0,0')}元/${
            visitData.yesterday.cz_customer
          }人`"
        />
        <a-divider style="margin-bottom: 8px; margin-top: 8px" />
        <field
          label="本月我的收款/付款客人数量："
          :value="`${numeral(visitData.month.cz_price).format('0,0')}元/${
            visitData.month.cz_customer
          }人`"
        />
        <field
          label="上月我的收款/付款客人数量："
          :value="`${numeral(visitData.last_month.cz_price).format('0,0')}元/${
            visitData.last_month.cz_customer
          }人`"
        />
      </a-card>
    </a-col>
    <a-col v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 12 }" style="margin-bottom: 24px">
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '20px 24px 8px 24px' }">
        <field-big
          label="今日我的耗单/耗单客人数量："
          :value="`${numeral(visitData.today.used_price).format('0,0')}元/${
            visitData.today.used_customer
          }人`"
        />
        <field
          label="昨日我的耗单/耗单客人数量："
          :value="`${numeral(visitData.yesterday.used_price).format('0,0')}元/${
            visitData.yesterday.used_customer
          }人`"
        />
        <a-divider style="margin-bottom: 8px; margin-top: 8px" />
        <field
          label="本月我的耗单/耗单客人数量："
          :value="`${numeral(visitData.month.used_price).format('0,0')}元/${
            visitData.month.used_customer
          }人`"
        />
        <field
          label="上月我的耗单/耗单客人数量："
          :value="`${numeral(visitData.last_month.used_price).format('0,0')}元/${
            visitData.last_month.used_customer
          }人`"
        />
      </a-card>
    </a-col>
  </a-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Field, FieldBig } from './charts';
import numeral from 'numeral';

export default defineComponent({
  name: 'StaffDeskTop',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    visitData: {
      type: [Array, Object],
      required: true,
    },
  },
  setup(props: any) {
    console.log('props', props.visitData);
    return {
      numeral,
    };
  },
  components: {
    Field,
    FieldBig,
  },
});
</script>
